import clsx from 'clsx';
import React from 'react';

import type { TypographyProps } from './Typography.types';

export const Typography = ({
  Tag,
  fontStyle,
  align,
  className,
  children,
  testid,
  ...rest
}: TypographyProps): JSX.Element => {
  return (
    <Tag
      className={clsx(fontStyle, className, {
        'text-left': align === 'left',
        'text-right': align === 'right',
        'text-center': align === 'center',
        'text-justify': align === 'justify',
        'text-nowrap': align === 'nowrap',
      })}
      data-testid={testid}
      {...rest}
    >
      {children}
    </Tag>
  );
};
